<div class="dropdown saved-filters-control" [class.is-disabled]="disabled">
  <button type="button" class="btn btn-light saved-filter-trigger" [class.is-active]="selectedFilter"
    data-bs-toggle="dropdown" data-bs-auto-close="outside" [disabled]="disabled">
    <i class="ri-bookmark-3-line"></i>
    <span>{{ 't-saved-filters.t-button' | translate }}</span>
    <span class="saved-filter-current text-truncate" *ngIf="selectedFilter">{{ selectedFilter.name }}</span>
    <span class="saved-filter-count" *ngIf="savedFilters.length > 0">{{ savedFilters.length }}</span>
  </button>

  <div class="dropdown-menu dropdown-menu-end saved-filter-panel">
    <div class="saved-filter-panel-header">
      <div class="min-w-0">
        <div class="saved-filter-panel-title">
          {{ 't-saved-filters.t-toolbar-label' | translate }}
        </div>
        <div class="saved-filter-panel-subtitle text-truncate" *ngIf="defaultFilter">
          <i class="ri-star-fill text-warning"></i>
          {{ defaultFilter.name }}
        </div>
      </div>

      <button type="button" class="btn btn-sm btn-primary saved-filter-save" [disabled]="isSaving"
        (click)="saveCurrentFilter()">
        <span class="spinner-border spinner-border-sm" *ngIf="isSaving"></span>
        <i class="ri-save-3-line" *ngIf="!isSaving"></i>
        <span>{{ 't-saved-filters.t-save-current-short' | translate }}</span>
      </button>
    </div>

    <div class="saved-filter-loading" *ngIf="isLoading">
      <span class="spinner-border spinner-border-sm"></span>
    </div>

    <div class="saved-filter-empty" *ngIf="!isLoading && savedFilters.length === 0">
      <i class="ri-bookmark-line"></i>
      <span>{{ 't-saved-filters.t-empty' | translate }}</span>
    </div>

    <div class="saved-filter-list" *ngIf="!isLoading && savedFilters.length > 0">
      <div class="saved-filter-row" *ngFor="let filter of savedFilters" [class.is-active]="filter.id === selectedFilterId">
        <button type="button" class="saved-filter-apply" (click)="applySavedFilter(filter)">
          <i class="ri-star-fill text-warning" *ngIf="filter.isDefault"></i>
          <i class="ri-bookmark-3-line text-muted" *ngIf="!filter.isDefault"></i>
          <span class="text-truncate">{{ filter.name }}</span>
          <small *ngIf="filter.isDefault">{{ 't-saved-filters.t-default' | translate }}</small>
        </button>

        <div class="saved-filter-row-actions">
          <button type="button" class="btn btn-sm btn-light btn-icon" (click)="updateFilter(filter, $event)"
            [ngbTooltip]="'t-saved-filters.t-update-current' | translate" container="body">
            <i class="ri-refresh-line"></i>
          </button>
          <button type="button" class="btn btn-sm btn-light btn-icon" (click)="renameFilter(filter, $event)"
            [ngbTooltip]="'t-rename' | translate" container="body">
            <i class="ri-edit-line"></i>
          </button>
          <button type="button" class="btn btn-sm btn-light btn-icon" (click)="setAsDefault(filter, $event)"
            [disabled]="filter.isDefault" [ngbTooltip]="'t-saved-filters.t-set-default' | translate" container="body">
            <i class="ri-star-line"></i>
          </button>
          <button type="button" class="btn btn-sm btn-light btn-icon text-danger" (click)="deleteFilter(filter, $event)"
            [ngbTooltip]="'t-delete' | translate" container="body">
            <i class="ri-delete-bin-line"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
